import React from 'react';
import './FourItems.css';
import imgEquipe from '../assets/equipe.jpg';
import imgEquipamentos from '../assets/equipamentos.png';
import imgEstrutura from '../assets/estrutura.JPG';
import imgCursos from '../assets/cursos.png';
import { Link } from 'react-router-dom';

const FourItems = () => {
  return (
    <section className="four-items-section">
      <div className="four-items-container">
        <Link to="/equipe" className="four-item">
          <img src={imgEquipe} alt="Equipe" className="four-item-image" />
          <div className="four-item-content">
            <h3 className="four-item-title">EQUIPE</h3>
            <p className="four-item-description">
              Conheça a nossa equipe de profissionais altamente qualificados, prontos para te ajudar a alcançar seus objetivos.
            </p>
          </div>
        </Link>

        <Link to="/equipamentos" className="four-item">
          <img src={imgEquipamentos} alt="Equipamentos" className="four-item-image" />
          <div className="four-item-content">
            <h3 className="four-item-title">EQUIPAMENTOS</h3>
            <p className="four-item-description">
              Temos os melhores equipamentos para treinos de força, cardio, musculação e muito mais.
            </p>
          </div>
        </Link>

        <Link to="/Estrutura" className="four-item">
          <img src={imgEstrutura} alt="Estrutura" className="four-item-image" />
          <div className="four-item-content">
            <h3 className="four-item-title">ESTRUTURA</h3>
            <p className="four-item-description">
              Nossa estrutura foi pensada para oferecer o máximo de conforto e funcionalidade para os treinos.
            </p>
          </div>
        </Link>

        <Link to="/Cursos" className="four-item">
          <img src={imgCursos} alt="Cursos" className="four-item-image" />
          <div className="four-item-content">
            <h3 className="four-item-title">PRODUTOS DIGITAIS</h3>
            <p className="four-item-description">
              Oferecemos produtos digitais para você melhorar seu desempenho e conhecimento.
            </p>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default FourItems;
